import React from 'react';
import { Card, CardProps, Col, Container, FormLabel } from 'react-bootstrap';
import { formatPrice } from '../../utils/utils';
import Radio from '../Radio/Radio';

type cardVariant = 'white' | 'default';

export type SelectableCardProps = CardProps &
  React.PropsWithChildren<{
    name?: string;
    title: string;
    subtitle1?: string;
    subtitle1WarningColor?: boolean;
    isCredit?: boolean;
    subtitle2?: string;
    totalSum?: number | null;
    prePaydPeriod?: number;
    costType?: string;
    prePaydPeriodSubtitle?: string;
    radioButtonValue: string;
    radioButtonDefaultChecked?: boolean;
    radioButtonDisabled?: boolean;
    selected?: boolean;
    disabled?: boolean;
    alwaysVisible?: boolean;
    variant?: cardVariant;
  }>;

const SelectableCard = ({
  name,
  title,
  subtitle1,
  subtitle1WarningColor,
  isCredit,
  subtitle2,
  totalSum,
  costType,
  prePaydPeriod,
  prePaydPeriodSubtitle,
  radioButtonValue,
  radioButtonDefaultChecked,
  radioButtonDisabled,
  selected,
  disabled,
  children,
  alwaysVisible,
  variant,
}: SelectableCardProps) => {
  const getContent = () => {
    if (selected)
      return <Container className="card-expanded-body">{children}</Container>;
    else if (alwaysVisible)
      return <Container className="card-expanded-body">{children}</Container>;

    return <></>;
  };

  return (
    <Container
      className={`px-0  custom-selectable-card ${selected ? 'selected' : ''}`}
    >
      <FormLabel>
        <Card className={`${variant && variant === 'white' ? 'bg-white' : ''}`}>
          <Card.Body>
            <Card.Title>
              <Container className="card-row">
                <Col sm={1}>
                  <Radio
                    name={name}
                    value={radioButtonValue}
                    disabled={radioButtonDisabled}
                    defaultChecked={radioButtonDefaultChecked}
                  />
                </Col>
                <Col sm={11} className="d-flex">
                  <Col sm={totalSum ? 6 : 8}>
                    <h6>{title}</h6>
                    {subtitle1 && (
                      <Card.Subtitle
                        className={`card-subtitle subtitle-1 mt-4 ${
                          subtitle1WarningColor ? 'red' : ''
                        }`}
                      >
                        {subtitle1}
                      </Card.Subtitle>
                    )}
                    {subtitle2 && (
                      <Card.Subtitle className="card-subtitle subtitle-2">
                        {subtitle2}
                      </Card.Subtitle>
                    )}
                  </Col>
                  {totalSum && (
                    <Col sm={2}>
                      <h5>
                        {formatPrice(totalSum, 'en-US', {
                          minimumFractionDigits: 0,
                        })}
                      </h5>
                    </Col>
                  )}
                  {prePaydPeriod !== undefined && (
                    <Col
                      sm={3}
                      className={`${totalSum ? 'total-sum' : ''} ${
                        disabled ? 'disabled ' : ''
                      }mobile-view-col-sm-3`}
                    >
                      <h4 className={isCredit ? 'credit' : ''}>
                        {costType
                          ? `${costType} (${formatPrice(prePaydPeriod)})`
                          : formatPrice(prePaydPeriod)}
                      </h4>
                      {prePaydPeriodSubtitle && (
                        <Card.Subtitle className="pre-paid-price subtitle-1">
                          {prePaydPeriodSubtitle}
                        </Card.Subtitle>
                      )}
                    </Col>
                  )}
                </Col>
              </Container>
            </Card.Title>
          </Card.Body>

          {<Container className={'px-0'}>{getContent()}</Container>}
        </Card>
      </FormLabel>
    </Container>
  );
};

export default SelectableCard;
